"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Geo = __importStar(require("./geo"));
const Loading = () => react_1.default.createElement("p", null,
    react_1.default.createElement("i", null, "Loading"));
exports.default = (props) => {
    const { address, LoadingComponent = react_1.default.createElement(Loading, null), width = 600, height = 450, zoomLevel = 14, lang = 'en', frameBorder = 0, style = { border: 0 }, tabIndex = 0 } = props;
    const [geoUrl, setUrl] = react_1.default.useState(null);
    try {
        Geo.latLonFromAddress(address).then(x => {
            const { lat, lon } = x[0];
            const url = Geo.mapFromLatLon(lat, lon, zoomLevel, props.apiKey, lang);
            setUrl(url);
        });
    }
    catch (err) {
        console.warn(err);
    }
    if (!geoUrl) {
        return LoadingComponent;
    }
    return react_1.default.createElement("iframe", { src: geoUrl, width: width, height: height, frameBorder: frameBorder, style: style, "aria-hidden": "false", tabIndex: tabIndex });
};
